import { css } from '@emotion/core';
import { variables, mq } from '../../../cssInJs';

const numberOfTiles = [1, 2, 3, 3]
//const marginLR = [14, 14, 14, 14]
const marginTB = [14, 14, 14, 14]

const widthPercent = (index) => 100 / numberOfTiles[index] + '%'

// brand colours (same as _scss/_variables.scss)
const logoBlue = '#2e3192';
const logoRed = '#c1272d';
const cardBg = '#ebebeb';

export const tileListStyle = {
  tiles: mq({
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    //marginLeft: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    //marginRight: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['1000px'],
    margin: 'auto'
  }),
  categoryList : mq({
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['1000px'],
    margin: 'auto',
    'div.ff.form-group' : {
      maxWidth: '250px'
    }
  })
}

export const tileStyle = {
  tile: mq({
    //paddingLeft: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    //paddingRight: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    paddingLeft : '10px',
    paddingRight : '10px',
    paddingTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    paddingBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexBasis: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexGrow: 0,
    flexShrink: 0
  }),
  tileLink: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    color: variables.fontColor,
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      textDecoration: 'none',
      color: variables.fontColor,
      transform: 'translateY(-3px)',
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12)',
    },
    '&:hover .productTile__button': {
      backgroundColor: logoBlue,
      color: '#fff',
    }
  },
  prdImage: {
    backgroundColor: '#000',
    marginBottom: 10,
  },
  bg: {
    // 3:2 image area
    paddingTop: '66%',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  },
  body: mq({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: cardBg,
    padding: ['1rem 1rem 1.2rem', null, '1.1rem 1.2rem 1.2rem'],
  }),
  name: css({
    fontFamily: variables.familyHeader,
    fontWeight: 400,
    textTransform: 'uppercase',
    fontSize: '1rem',
    lineHeight: 1.15,
    color: logoBlue,
    marginBottom: '0.5rem',
  }),
  shortDes: css({
    fontSize: '0.8rem',
    lineHeight: 1.35,
    color: '#333',
    marginBottom: '1rem',
  }),
  price: css({
    fontSize: '0.75rem',
    fontWeight: 700,
    color: logoRed,
    marginBottom: '1.2rem',
  }),
  button: css({
    marginTop: 'auto',
    display: 'block',
    textAlign: 'center',
    fontSize: '0.75rem',
    padding: '0.4rem 0.5rem',
    border: `1px solid ${logoBlue}`,
    color: logoBlue,
    backgroundColor: 'transparent',
    transition: 'background-color 0.2s, color 0.2s',
  })
}